import { render, staticRenderFns } from "./form-bmi.vue?vue&type=template&id=67d916ca&scoped=true"
import script from "./form-bmi.vue?vue&type=script&lang=js"
export * from "./form-bmi.vue?vue&type=script&lang=js"
import style0 from "./form-bmi.vue?vue&type=style&index=0&id=67d916ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d916ca",
  null
  
)

export default component.exports